import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

import Img from "gatsby-image"
import ArrowRight from "../../../images/arrow-right.svg"

export default function ProteinColdBrew(props) {
  const images = useStaticQuery(graphql`
    query cupImageProteinColdBrew {
      cupImageLarge: file(
        relativePath: { eq: "front-page-flavors/protein-cold-brew.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 320) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cupImageMedium: file(
        relativePath: { eq: "front-page-flavors/protein-cold-brew.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 260) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cupImageSmall: file(
        relativePath: { eq: "front-page-flavors/protein-cold-brew.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 180) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const cupSources = [
    images.cupImageLarge.childImageSharp.fluid,
    {
      ...images.cupImageMedium.childImageSharp.fluid,
      media: `(max-width: 768px)`,
    },
    {
      ...images.cupImageSmall.childImageSharp.fluid,
      media: `(max-width: 540px)`,
    },
  ]

  return (
    <>
      <Img fluid={cupSources} />
      <div className="flavor-label">
        <h2>Cold Brew</h2>
        <Link to="/flavors" state={{ flavor: "proteinColdBrew" }}>
          Check out the details
          <ArrowRight />
        </Link>
      </div>
    </>
  )
}

const Svg = styled.svg`
  .active-bg-1,
  .active-bg-2 {
    transition: all 0.2s ease-in-out;
    opacity: ${props => (props.active ? 1 : 0)};
  }

  .border {
    transition: all 0.2s ease-in-out;
    fill: ${props => (props.active ? "#83311C" : props.theme.color.primary)};
  }
`
export function ProteinColdBrewThumb(props) {
  const { active } = props

  return (
    <>
      {/* Chocolate Bar */}
      <Svg
        version="1.1"
        viewBox="0 0 146 146"
        xmlns="http://www.w3.org/2000/svg"
        active={active}
      >
        <path
          className="active-bg-1"
          d="m56.504 65.616c-0.82843 0-11.353 0.82843-11.353 0v45.371c0 2.66 2.4884 5.6573 4.6484 5.6573l30.975 0.4131c-0.36446-0.47853 11.552-16.409 12.341-15.822v-35.062c-0.065922 0.01272-12.27-0.17291-36.611-0.55688z"
          fill="#AD6B3A"
        />
        <path
          className="active-bg-2"
          d="m105.24 111.9c1.3759 1.0595 2.211 2.6748 2.28 4.41 0.14718 2.3825-0.4846 4.7481-1.8 6.74-2.12 3.37-5.45 5.25-8.29 5 1.3919-0.70892 2.5821-1.7581 3.46-3.05 1.0005-1.5724 1.2392-3.5119 0.65-5.28-0.85-2.76 2.15-6.12 3.7-7.82zm-3.2-0.88c-1.88 2.15-4.23 5.49-3.5 9 0.04 0.2 0.08 0.39 0.14 0.59 0.33204 0.92714 0.20986 1.9564-0.33 2.78-0.8428 1.13-1.9954 1.9881-3.3148 2.472l-0.28523 0.097951c-0.25212 0.093919-0.50917 0.17404-0.77 0.24-1.9-2.39-1.78-6.58 0.52-10.22 1.93-3.06 4.88-4.89 7.54-4.96zm-20.59-7.17 0.20172 0.49513 0.21322 0.49512c1.0745 2.4228 2.7971 5.2253 5.6553 6.205l0.29974 0.094752c0.19027 0.063876 0.38389 0.11729 0.58 0.16 0.97651 0.1384 1.8335 0.72206 2.32 1.58 0.40326 0.77743 0.62869 1.6348 0.66 2.51-0.19 0.36-0.36 0.72-0.52 1.09-0.23679 0.54275-0.43723 1.1007-0.6 1.67-2.8 0.05-5.96-1.95-7.9-5.31-1.2317-2.0454-1.7684-4.4344-1.53-6.81 0.085633-0.75577 0.2951-1.4923 0.62-2.18zm4.58-2.9601c0.92594 0.015912 1.8398 0.21296 2.69 0.58011 2.175 0.97296 3.9752 2.6258 5.13 4.71 0.78916 1.3461 1.3056 2.8344 1.52 4.38-0.59906 0.47991-1.1638 1.0012-1.69 1.56-0.10488-0.26513-0.22853-0.52245-0.37-0.77-0.92346-1.6092-2.5271-2.7126-4.36-3-2.84-0.53-4.42-4.75-5.2-6.92 0.7065-0.35805 1.488-0.54313 2.28-0.54011zm-21.785 0.34825 3.6557 3.6557-3.6557 3.6557-3.6557-3.6557 3.6557-3.6557zm-4.4449-17.838v5h-5v-5h5zm23.646-9.1817 3.8847 8.2181-8.2181 3.8847-3.8847-8.2181 8.2181-3.8847z"
          fill="#D28E5F"
        />
        <path
          className="border"
          d="m83.33 5.0305c0.66102 0.13495 1.1445 0.69199 1.1955 1.3533l0.0042248 0.14318-5.32 26.3h7.76c0.50451 0.0020293 0.9742 0.25754 1.25 0.68l0.35833 0.57058 0.30926 0.51897c1.7706 3.0284 6.4083 11.904 6.5396 21.85l0.0028472 0.4303-1e-3 46.211 0.061 0.078922c0.27133 0.37072 0.52696 0.7526 0.76622 1.1446l0.23378 0.39537c0.76531 1.3162 1.3219 2.7432 1.65 4.23 2.1871-1.0507 4.6964-1.212 7-0.45 0.26117 0.032276 0.50937 0.13224 0.72 0.29 0.26394 0.12623 0.52097 0.26643 0.77 0.42 2.2316 1.4813 3.6519 3.9043 3.8617 6.5636l0.018313 0.29642c0.24192 3.025-0.50561 6.0467-2.13 8.61-2.56 4.04-6.62 6.3909-10.37 6.3909-1.5191 0.012276-3.0106-0.40742-4.3-1.2109-2.78-1.73-4.12-5.09-3.88-8.73-2.1797-0.15779-4.2656-0.9504-6-2.28-1.6307-1.2067-2.9928-2.7391-4-4.5-1.5682-2.6107-2.2422-5.6616-1.92-8.69 0.21957-2.1915 1.229-4.2282 2.84-5.73 0.14971-0.2064 0.34924-0.37154 0.58-0.48 0.23-0.17 0.48-0.34 0.73-0.49 2.3473-1.2844 5.1495-1.4147 7.599-0.36621l0.28102 0.12621c0.77611 0.32801 1.516 0.735 2.208 1.2143l0.28098 0.20174 1e-3 -33.516-0.16 0.0077288-0.16-0.0077288h-19.73l-2.64 13.09c-0.13633 0.64996-0.67889 1.1288-1.3291 1.1927l-0.14088 0.0072664c-0.099758 0.0098276-0.20024 0.0098276-0.3 0-0.39125-0.077023-0.73529-0.30766-0.95518-0.6403-0.1924-0.29107-0.27569-0.63899-0.23828-0.98278l0.023459-0.14691 2.54-12.49-23.34-9.219e-4v44.381c0 2.5818 1.658 4.6925 3.7305 4.8144l0.18952 0.005563h30.83c0.75054 1.0172 1.6329 1.9293 2.6235 2.7124l0.37649 0.28759h-33.83c-3.7436 0-6.7957-3.371-6.9163-7.5624l-0.003701-0.25762v-54.14c0-12.21 6.91-22.92 7.2-23.37 0.25223-0.3804 0.66026-0.62504 1.1091-0.67182l0.15095-0.0081806h24.69l5.49-26.89c0.27142-0.66995 0.98204-1.051 1.6903-0.90645zm21.91 106.87-0.55544 0.6164c-1.6064 1.8135-3.9013 4.7464-3.1446 7.2036 0.58924 1.7681 0.35048 3.7076-0.65 5.28-0.87795 1.2919-2.0681 2.3411-3.46 3.05 2.7565 0.23294 5.9745-1.5312 8.0998-4.7074l0.19016-0.29261v0.01c1.3154-1.9919 1.9472-4.3575 1.8-6.74-0.066088-1.7388-0.90147-3.3582-2.28-4.42zm-3.2-0.91c-2.66 0.1-5.61 1.93-7.54 4.96-2.3 3.64-2.42 7.83-0.52 10.22 0.17389-0.043975 0.3461-0.094241 0.51628-0.15069l0.25372-0.089306c1.4384-0.46076 2.697-1.3593 3.6-2.57 0.5013-0.76481 0.64245-1.7069 0.39421-2.5799l-0.15671-0.49512c-0.0275-0.0975-0.0475-0.195-0.0475-0.295-0.73-3.48 1.62-6.82 3.5-9zm-20.59-7.15c-0.3249 0.68772-0.53437 1.4242-0.62 2.18-0.23842 2.3756 0.29832 4.7646 1.53 6.81 1.9 3.31 5.1 5.31 7.9 5.31 0.16277-0.56935 0.36321-1.1272 0.6-1.67 0.16-0.36 0.33-0.72 0.52-1.09-0.031306-0.87523-0.25674-1.7326-0.66-2.51-0.48647-0.85794-1.3435-1.4416-2.32-1.58l-0.29219-0.072063-0.28781-0.087937c-3.45-0.98-5.31-4.62-6.37-7.29zm-17.2-6.2329c0.34853 0 0.68437 0.12211 0.95042 0.34247l0.10958 0.10039 5.78 5.77c0.27865 0.28286 0.43643 0.66296 0.44 1.06-3.063e-4 0.34798-0.12152 0.68339-0.34032 0.95008l-0.09968 0.10992-5.78 5.78c-0.54903 0.54835-1.4172 0.58262-2.0061 0.10282l-0.11388-0.10282-5.78-5.78c-0.28138-0.28104-0.43965-0.66231-0.44-1.06 0.0031218-0.34741 0.12431-0.68186 0.34124-0.94953l0.098764-0.11047 5.78-5.77c0.27993-0.28337 0.66168-0.44286 1.06-0.44286zm21.79 3.2829h-0.01c-0.80803-2.53e-4 -1.6041 0.19533-2.32 0.57l0.29946 0.81576 0.16882 0.43758c0.88405 2.2423 2.3735 5.2266 4.7317 5.6667 1.8329 0.28742 3.4365 1.3908 4.36 3 0.14147 0.24755 0.26512 0.50487 0.37 0.77 0.54226-0.56062 1.1237-1.0819 1.74-1.56-0.19487-1.4051-0.63943-2.7628-1.3116-4.0094l-0.20844-0.37058c-1.1497-2.0954-2.9505-3.7593-5.13-4.74-0.85018-0.36716-1.7641-0.5642-2.69-0.58zm-21.795 0.34814-3.6557 3.6557 3.6557 3.6557 3.6557-3.6557-3.6557-3.6557zm-2.9449-20.838c0.82843 0 1.5 0.67157 1.5 1.5v8c0 0.82843-0.67157 1.5-1.5 1.5h-8c-0.82843 0-1.5-0.67157-1.5-1.5v-8c0-0.82843 0.67157-1.5 1.5-1.5h8zm24.083-9.0659 0.078598 0.11837 0.068292 0.12753 5.16 10.89c0.17125 0.35934 0.19265 0.77202 0.05948 1.1471-0.11652 0.32823-0.34302 0.60416-0.63866 0.78252l-0.13082 0.070334-10.89 5.21c-0.2002 0.09389-0.41889 0.14173-0.64 0.14013-0.53262-0.001162-1.0214-0.28226-1.2918-0.73306l-0.068205-0.12707-5.17-10.93c-0.3288-0.7071-0.063541-1.5393 0.59247-1.9317l0.12753-0.068292 10.89-5.17c0.66291-0.30825 1.4357-0.094378 1.8531 0.4741zm-25.583 12.066h-5v5h5v-5zm23.646-9.1817-8.2181 3.8847 3.8847 8.2181 8.2181-3.8847-3.8847-8.2181zm-7.8963-38.388h-23.25l-0.34167 0.59375c-1.2068 2.1419-5.2153 9.6529-5.5579 15.498-0.21631 1.3802-0.35602 2.7993-0.39153 4.2374l-0.0089399 0.72056v6.8l23.93-0.04 5.62-27.76-0.01-9.219e-4 0.01-0.049078zm3.09 0-5.65 27.81h19.12c0.070744-0.010211 0.14222-0.013615 0.21346-0.010211l0.10654 0.010211v-6.8c0-8.7948-4.0791-17.042-5.8774-20.261l-0.42262-0.73891-7.49-0.01z"
          fill="#83311C"
        />
      </Svg>
    </>
  )
}
